export const FETCH_SELECTED_GENRE = 'FETCH_SELECTED_GENRE'
export const FETCH_SELECTED_GENRE_REQUEST = 'FETCH_SELECTED_GENRE_REQUEST'
export const FETCH_SELECTED_GENRE_SUCCESS = 'FETCH_SELECTED_GENRE_SUCCESS'